export let initialState: { state: string } = {
  state: "",
};

const getDefaultState = () => ({
  state: "",
});

export type IState = typeof initialState;

export enum IAction {
  SET_STATE = "set_state",
}
export const componentIsUnmounting = () => {
  initialState = getDefaultState();
};

const actionHandlers = Object.fromEntries(
  Object.values(IAction).map((action) => [action, (_: IState, payload: IState) => ({ ...payload })])
);

export function reducer(state: IState, { type, payload }: { type: IAction; payload: IState }): IState {
  const actionHandler = actionHandlers[type] || ((state) => state);
  return actionHandler(state, payload);
}
